<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview
        id="measureObjTree"
        ref="measureObjTree"
        :fields="fields"
        :nodeSelected="nodeSelected"
      ></ejs-treeview>
    </div>
  </div>
</template>

<script>
class TreeDatas {
  constructor(dataSource) {
    this.dataSource = !!dataSource ? dataSource : [{ children: [] }];
    this.id = 'id';
    this.text = 'text';
    this.child = 'children';
    this.expanded = 'state';
  }
}

export default {
  name: 'measureObjTree',
  data() {
    return {
      fields: new TreeDatas(),
      selectedNodeId: undefined
    };
  },
  mounted() {
    this.getMeasureObjTree();
  },
  methods: {
    // 加载网元树数据
    getMeasureObjTree() {
      const _this = this;
      this.$axios
        .get('/lte/pm/tree/currenttime/measureObjTree.html?systemId=1')
        .then(response => {
          console.log('getMeasureObjTree', response);
          // 页面加载时默认选中一个节点
          _this.selectFirstNode(response.data);
          _this.fields = new TreeDatas(response.data);
        });
    },
    // 计算第一个叶子节点，并设置seleced属性为true，同时将叶子节点的ID赋值给this.selectedNodeId
    selectFirstNode(data) {
      if (data) {
        if (data[0].children && data[0].children.length > 0) {
          this.selectFirstNode(data[0].children);
        } else {
          data[0].selected = true;
          this.selectedNodeId = data[0].id;
        }
      }
    },
    // 根据this.selectedNodeId的值触发单击事件
    loadSeatTreeById() {
      this.nodeSelected({ nodeData: { id: this.selectedNodeId } });
    },
    // 单击节点
    nodeSelected: function (args) {
      this.selectedNodeId = args.nodeData.id;
      const systemId = 1;
      let counterTypeId = '';
      let neTypeId = '';
      let neVersionId = '';
      let typeCode = '';
      let counterTypeName = '';

      const attributes = this.$refs.measureObjTree.getTreeData(
        args.nodeData.id
      )[0].attributes;

      if (attributes) {
        counterTypeId = attributes.counterTypeId
          ? attributes.counterTypeId
          : '';
        neTypeId = attributes.neTypeId ? attributes.neTypeId : "";
        neVersionId = attributes.neVersionId ? attributes.neVersionId : "";
        typeCode = attributes.measureObjectTypeCode
          ? attributes.measureObjectTypeCode
          : '';
        counterTypeName = attributes.counterTypeNameCn
          ? attributes.counterTypeNameCn
          : '';
      }

      const params = {
        systemId: systemId,
        counterTypeId: counterTypeId,
        neTypeId: neTypeId,
        neVersionId: neVersionId,
        typeCode: typeCode,
        counterTypeName: counterTypeName
      };
      // 只有叶子节点才提交
      if (counterTypeId) {
        this.$emit('selectMeasureEmit', params);
      }
    },
    // 获取选中节点参数
    getSelectMeasureInfo() {
      const measureObj = this.$refs.measureObjTree.getTreeData(
        this.selectedNodeId
      )[0];
      return measureObj;
    }
  }
};
</script>

<style>
</style>
